import User from "@/lib/user"
import { SystemMessagesAPI } from "@/lib/api"
import {
  SET_SYSTEM_MESSAGES,
  ADD_SYSTEM_MESSAGE,
  UPDATE_SYSTEM_MESSAGE,
  DELETE_SYSTEM_MESSAGE
} from "@/store/mutationTypes"
const state = {
  all: []
}

// getters
const getters = {
  getMessages: (state, getters, rootState, rootGetters) => {
    return state.all
  },
  getMessagesByUserId: (state, getters) => id => {
    return getters.getMessages.filter(el => el.to_user_id === parseInt(id))
  }
}

// actions
const actions = {
  async loadMessages({ commit }, userId) {
    commit(SET_SYSTEM_MESSAGES, await SystemMessagesAPI.list(userId))
  },
  async addMessage({ commit }, { toUserId, body }) {
    commit(ADD_SYSTEM_MESSAGE, await SystemMessagesAPI.add(toUserId, body))
  },
  async updateMessage({ commit }, { id, body }) {
    commit(UPDATE_SYSTEM_MESSAGE, await SystemMessagesAPI.update(id, body))
  },
  async deleteMessage({ commit }, messageId) {
    commit(DELETE_SYSTEM_MESSAGE, await SystemMessagesAPI.delete(messageId))
  }
}

// mutations
const mutations = {
  [SET_SYSTEM_MESSAGES](state, messages) {
    state.all = messages
  },
  [ADD_SYSTEM_MESSAGE](state, message) {
    state.all.unshift(message)
  },
  [UPDATE_SYSTEM_MESSAGE](state, message) {
    let foundMessage = state.all.find(el => el.id === message.id)
    if (foundMessage) {
      foundMessage.body = message.body
    } else {
      state.all.unshift(message)
    }
  },
  [DELETE_SYSTEM_MESSAGE](state, messageId) {
    let index = state.all.findIndex(el => el.id === messageId)
    state.all.splice(index, 1)
  },
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
